// **************************************************************************
// NAVIGATION STATE
// **************************************************************************

export type NavigationView =
    | "main"
    | "quote-page"
    | "customer-page"
    | "contact-page"
    | "contract-page";

export type AsideTab = "items" | "summary" | "contract";

export type SidebarGroup = "central-support" | "contract-admin" | "super-user" | "developer";

export interface NavigationState {
    view: NavigationView;
    activeTab: string | null;
    sidebarExpanded: boolean;
    asideExpanded: boolean;
    asideTab: AsideTab;
    settingsDrawerVisible: boolean;
    currentUrl: string;
    hasNavigated: boolean;
    expandedSidebarGroup: SidebarGroup | null;
}

export const initialNavigationState: NavigationState = {
    view: "main",
    activeTab: null,
    sidebarExpanded: true,
    asideExpanded: false,
    asideTab: "summary",
    settingsDrawerVisible: false,
    currentUrl: "",
    hasNavigated: false,
    expandedSidebarGroup: null,
};
